<script>
    import { section } from "../store/section.js";
    import { token } from "../store/token.js";
    import { device_info } from "../store/device_info.js";
    import { user_info_list } from "../store/user_info_list.js";

    import { fetch_device_login_list } from "../api/request.js";

    import HeadingContent from "./component/HeadingContent.svelte";

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    const remove_device = () => {
        let result = confirm(
            `Do you really want to remove ${
                $device_info.device_name == null
                    ? "unknown"
                    : $device_info.device_name
            }?`,
        );

        if (result == true) {
            fetch(`${process.env.API_ROOT}/user/device/remove`, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: "Bearer " + $token,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    device_id: $device_info.id,
                }),
            })
                .then((data) => {
                    user_info_list.set({});
                    set_section("account/security");
                })
                .catch(console.log);
        }
    };
</script>

<div class="settings-holder settings-active">
    <!-- Settings Security Device Details (Second Level)-->
    <div class="settings-holder-content content-active">
        <HeadingContent
            title="Device details"
            back_button_enabled={true}
            back_button_click_action={() => {
                set_section("account/security");
            }}
        />
        <!--
        <div class="settings-heading">
            <div
                class="heading-block"
                on:click={() => {
                    set_section("account/security");
                }}
            >
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title">Device details</strong>
                    </div></a
                >
            </div>
        </div>
        -->
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="card-details card-join-bottom card">
                        <div class="card-body">
                            <div class="device-ico-holder">
                                <div class="ico-holder">
                                    {#if $device_info.device_platform == "android"}
                                        <img
                                            src="../account/images/avatar-android.svg"
                                            alt="Android"
                                            width="40"
                                            height="48"
                                        />
                                    {:else if $device_info.device_platform == "macos" || $device_info.device_platform == "ios"}
                                        <img
                                            src="../account/images/avatar-apple.svg"
                                            alt="Apple"
                                            width="40"
                                            height="48"
                                        />
                                    {:else}
                                        <img
                                            src="../images/Vector.svg"
                                            loading="lazy"
                                            alt=""
                                            class="device-icon"
                                            width="40"
                                            height="48"
                                        />
                                    {/if}
                                </div>
                            </div>
                            <strong class="h5 card-title"
                                >{$device_info.device_name == null
                                    ? "unknown"
                                    : $device_info.device_name}</strong
                            >
                            <dl class="list-details">
                                <dt>Recent Activity</dt>
                                <dd>
                                    <span class="place-activity"
                                        >{$device_info.location}</span
                                    >
                                    <!--–<span class="time-activity"
                                        >About an hour ago.</span
                                    >-->
                                </dd>
                            </dl>
                            <dl class="list-details">
                                <dt>Connected</dt>
                                <dd>
                                    <time class="time-activity"
                                        >{new Date(
                                            $device_info.created_at,
                                        ).toDateString()}</time
                                    >
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic row-mobile-reverse gx-1">
                            <div class="col">
                                <p>
                                    You will be logged out from <span
                                        class="text-white"
                                        >{$device_info.device_name == null
                                            ? "unknown"
                                            : $device_info.device_name}</span
                                    > device
                                </p>
                            </div>
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-danger"
                                    href="#"
                                    on:click={() => {
                                        remove_device();
                                    }}>Disconnect Device</a
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-h-100" style="margin-top:40px">
                    <div class="intro-text text-small">
                        <p>Recent login activity from this device</p>
                    </div>
                    <div
                        class="card-settings-main card-h-100 card bg-transparent-mobile"
                    >
                        {#await fetch_device_login_list($device_info.device_name, $token)}
                            <div class="card-body">
                                <nav>
                                    <ul
                                        class="nav-second-level nav-settings nav-text-hide-mobile"
                                    >
                                        <li>
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Loading
                                                                    recent
                                                                    activity</strong
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        {:then data}
                            <div class="card-body">
                                <nav>
                                    <ul
                                        class="nav-second-level nav-settings nav-text-hide-mobile"
                                    >
                                        {#each data as connected_device}
                                            <li
                                                on:click={() => {
                                                    device_info.set(
                                                        connected_device,
                                                    );
                                                    set_section(
                                                        "account/security/device_detail",
                                                    );
                                                }}
                                            >
                                                <a
                                                    class="opener-third-level"
                                                    href="#"
                                                >
                                                    <div
                                                        class="df-row df-aic gx-2"
                                                    >
                                                        <div class="col-auto">
                                                            <span
                                                                class="ico-holder"
                                                            >
                                                                {#if connected_device.device_platform == "android"}
                                                                    <img
                                                                        src="../images/Vector-1.svg"
                                                                        loading="lazy"
                                                                        alt=""
                                                                        class="device-icon"
                                                                        width="17"
                                                                        height="20"
                                                                    />
                                                                {:else if connected_device.device_platform == "macos" || connected_device.device_platform == "ios"}
                                                                    <img
                                                                        src="../images/Vector.svg"
                                                                        loading="lazy"
                                                                        alt=""
                                                                        class="device-icon"
                                                                        width="17"
                                                                        height="20"
                                                                    />
                                                                {:else}
                                                                    <img
                                                                        src="../images/Vector.svg"
                                                                        loading="lazy"
                                                                        alt=""
                                                                        class="device-icon"
                                                                        width="17"
                                                                        height="20"
                                                                    />
                                                                {/if}
                                                            </span>
                                                        </div>
                                                        <div class="col">
                                                            <div
                                                                class="opener-text"
                                                            >
                                                                <div
                                                                    class="df-row df-jcb df-aic"
                                                                >
                                                                    <div
                                                                        class="col"
                                                                    >
                                                                        <strong
                                                                            class="nav-title"
                                                                            >{connected_device.device_name ==
                                                                            null
                                                                                ? "unknown"
                                                                                : connected_device.device_name}</strong
                                                                        >
                                                                        <div
                                                                            class="nav-text"
                                                                        >
                                                                            <p>
                                                                                Recent
                                                                                Activity
                                                                                –
                                                                                {connected_device.location}
                                                                                –
                                                                                {new Date(
                                                                                    connected_device.created_at,
                                                                                ).toDateString()}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="col-auto"
                                                                    >
                                                                        <i
                                                                            class="icon icon-chevron-right"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div></a
                                                >
                                            </li>
                                        {/each}
                                    </ul>
                                </nav>
                            </div>
                        {:catch error}
                            {error}
                            <p>Failed to load the list.</p>
                        {/await}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
